import React, { useState } from 'react';
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import SvgIcon from '../Helpers/Svg/SvgIcon';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';
import { Menu as MenuIcon } from '@mui/icons-material';
import CustomerSupportPhone from '../Account/CustomerSupportPhone';
import NavbarUrlManager from './NavbarUrlManager';
import ContactHelpIcon from '../../icons/contactHelp.svg?react';
import CustomerSupportEmail from '../Account/CustomerSupportEmail';
import './Navbar.scss';

export default function NavbarHeader() {
  const navigate = useNavigate();
  let navbarLogoUrl;
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const phone = accountObj.account.phone;
  const primaryColor = accountObj.accountOverrides ? accountObj.accountOverrides[0].primaryColor : accountObj.account.primaryColor || "#4C4C4C";
  const needsAnalysisDisabled = !accountObj || (accountObj && !accountObj.enableNeedsAnalysis);
  const disableLogoLink = accountObj && accountObj.account && accountObj.account.disableLogoLink;
  const disableCompareMenu = accountObj && accountObj.account && accountObj.account.disableCompareMenu;
  const home = document.location.pathname === '/';
  const navbarUrlManager = NavbarUrlManager(accountObj.account.domain);
  const navbarUrl = navbarUrlManager.url;
  const partnerContactInformation = isValidJSON(accountObj.account.partnerContactInformation) ? JSON.parse(accountObj.account.partnerContactInformation) : null;
  const isStandAlone = navbarUrlManager.isStandAlone;
  const [expanded, setExpanded] = useState(false);
  if (accountObj && accountObj.account && accountObj.account.logoUrl) {
    if (home && accountObj.account.logoUrlHome) {
      navbarLogoUrl = accountObj.accountOverrides ? accountObj.accountOverrides[0].homeLogoUrl : accountObj.account.logoUrlHome;
    } else {
      navbarLogoUrl = accountObj.accountOverrides ? accountObj.accountOverrides[0].landingLogoUrl : accountObj.account.logoUrl;
    }
  } else {
    if (home) {
      navbarLogoUrl = '/logos/covr-logo-white.svg';
    } else {
      navbarLogoUrl = '/logos/covr-logo.svg';
    }
  }

  const phoneNumber = CustomerSupportPhone();
  const emailAddress = CustomerSupportEmail();

  const { domain } = accountObj.account;
  const isEtradeNav = (domain.toLowerCase().indexOf("etrade") !== -1 || domain.toLowerCase().indexOf("msatwork") !== -1);
  const visibleProducts = accountObj && accountObj.accountProducts ? accountObj.accountProducts.filter(content => !content.isHidden) : [];
  
  function isValidJSON(value) {
    if (typeof value !== "string") {
      return false;
    };

    try {
      JSON.parse(value);
      return true;
    } catch (e) {
      return false;
    };
  };

  const handleProductNavigation = (product) => {
    if (product.productLandingUrl !== '/landing/simplified-issue-term') {
      return;
    }

    navigate('/landing/term-insurance', { state: { isFromSimplifiedIssueTerm: true } });
  };

  return (
    <div role="banner" style={{'--primary-override-color': primaryColor}}>
      <Navbar id="navbar" expand="md" variant={home ? 'dark' : 'light'} className={home ? "transparent" : ''}>

        <Navbar.Brand className="me-auto">
          {!disableLogoLink ?
            <div className="logo">
              <a href={navbarUrl}><img src={navbarLogoUrl} className={home ? "bigLogo" : "normalLogo"} alt={`${accountObj.account.accountName || 'Covr'}`} /></a>
              { !isEtradeNav && <a href={`tel:${phone}`}><span className="account-phone">{phone}</span></a> }
            </div>
            :
            <div className="logo">
              <img src={navbarLogoUrl} className={home ? "bigLogo" : "normalLogo"} alt={`${accountObj.account.accountName || 'Covr'}`} />
              { !isEtradeNav && <span className="account-phone">{phone}</span> }
            </div>
          }
        </Navbar.Brand>

        { !isEtradeNav && <Navbar.Toggle className='button-text' aria-controls="basic-navbar-nav" aria-expanded={expanded} onClick={() => setExpanded(!expanded)} >
          <MenuIcon fontSize="large" />
        </Navbar.Toggle> }

        <Navbar.Collapse id="basic-navbar-nav" className={isEtradeNav ? "no-collapse show" : ""}>
          <Nav defaultActiveKey="/">
            {!isStandAlone && !disableCompareMenu && !isEtradeNav && visibleProducts.length > 0 && (
              <NavDropdown title="Explore" id="compare-dropdown" role="menu" >
                {visibleProducts && visibleProducts.map((product, index) =>
                  <NavDropdown.Item
                    key={index}
                    href={product.productLandingUrl === '/landing/simplified-issue-term' ? '/landing/term-insurance' : product.productLandingUrl}
                    target={product.openInNewTab ? "_blank" : "_self"}
                    role="menuitem"
                    onClick={() => handleProductNavigation(product)}>
                    <div className="d-flex align-items-center">
                      <SvgIcon iconName={product.productIconPath} /> {product.displayName}
                    </div>
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            )}
            {!needsAnalysisDisabled && <Nav.Link href="#">Calculate</Nav.Link>}

            {isEtradeNav && <div className="phone-container">
              <p className="primaryColorText"><SvgIcon color={primaryColor} iconName="phoneCall" fontSize="medium"/>{phoneNumber}</p>
            </div>}

            <NavDropdown title={isEtradeNav ? <ContactHelpIcon /> : "Contact"} id="contact-dropdown" className={isEtradeNav ? `contact-dropdown minimal primaryColorBackground` : "contact-dropdown"} role="menu">
              <div className="contact-container">
                <NavDropdown.Item className="hoverPrimaryColor" href={`tel:${phoneNumber}` } role="menuitem">
                  <div className="d-flex stack">
                    <h3>Call us at:</h3> 
                    <p className={isEtradeNav ? `emphasize primaryColorText` : ""}>{phoneNumber}</p>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item className="hoverPrimaryColor" href={`mailto:${emailAddress}`} role="menuitem">
                  <div className="d-flex stack">
                    <h3>Email us at:</h3> 
                    <p className={isEtradeNav ? `emphasize primaryColorText` : ""}>{emailAddress}</p>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item href="#" className="non-clickable" role="menuitem">
                  <div className="d-flex stack">
                    <h3>Hours of Operation:</h3>
                    <p className='compress'>Monday - Friday<br/>8:00 AM ET to 6:00 PM ET</p>
                  </div>
                </NavDropdown.Item>
              </div>
              { partnerContactInformation && 
              <div className="contact-container partner">
                { partnerContactInformation.phoneNumber && <NavDropdown.Item className="hoverPrimaryColor" href={`tel:${partnerContactInformation.phoneNumber.number}` } role="menuitem">
                  <div className="d-flex stack">
                    <h3>Call {accountObj.account.accountName} at:</h3> 
                    <p className={isEtradeNav ? `emphasize primaryColorText` : ""}>{partnerContactInformation.phoneNumber.display}</p>
                  </div>
                </NavDropdown.Item> }
                { partnerContactInformation.emailAddress && <NavDropdown.Item className="hoverPrimaryColor" href={`mailto:${partnerContactInformation.emailAddress.link}`} role="menuitem">
                  <div className="d-flex stack">
                    <h3>Email {accountObj.account.accountName} at:</h3> 
                    <p className={isEtradeNav ? `emphasize primaryColorText` : ""}>{partnerContactInformation.emailAddress.display}</p>
                  </div>
                </NavDropdown.Item> }
                { partnerContactInformation.website && <NavDropdown.Item className="hoverPrimaryColor" href={`${partnerContactInformation.website.link}`} target="_blank" role="menuitem">
                  <div className="d-flex stack">
                    <h3>Visit {accountObj.account.accountName} at:</h3> 
                    <p className={isEtradeNav ? `emphasize primaryColorText` : ""}>{partnerContactInformation.website.display}</p>
                  </div>
                </NavDropdown.Item> }
              </div>}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div >
  );
}
